import { AlrBase, ApiResultCode, IAlrBaseConstParam } from '@/models/response/AlrBase'
import { AloError } from '@/models/alo/AloError';

interface IAlrContainerConstParam extends IAlrBaseConstParam {
    data:any
    dataTypeName?:string
}

export class AlrContainer<Talr> extends AlrBase {    

    public data:Talr|AloError
    public dataTypeName:string
    
    constructor({data,dataTypeName="",...args}:IAlrContainerConstParam,factory:(obj:any) => Talr) {        
        super(args)  
        this.dataTypeName = dataTypeName
        if(this.dataTypeName == 'AloError') {
            this.data = new AloError(data)        
        }
        else{
            this.data = factory(data)        
        }
                
    }
}